<script setup lang="ts">
export interface SaferGamblingQaPanelProps {
    title: string
    videoId?: string
    body: any
    ctas?: Array<{
        label: string
        url: string
        variant?: 'primary' | 'secondary'
    }>
    expandableTextBlocks?: Array<{
        title: string
        content: any
    }>
    showHeader?: boolean
    borderless?: boolean
}

const props = withDefaults(defineProps<SaferGamblingQaPanelProps>(), {
    showHeader: true,
    ctas: () => [],
    expandableTextBlocks: () => [],
    borderless: false
})
</script>

<template>
    <UIExpandable
        :class="['qa-panel', { 'qa-panel--borderless': props.borderless }]"
        :show-header="props.showHeader"
    >
        <template #header>
            <div class="qa-panel__header">
                {{ title }}
                <UIIcon
                    class="qa-panel__header-icon"
                    name="plus"
                    size="14px"
                />
            </div>
        </template>

        <SaferGamblingQaContent
            :video-id="props.videoId"
            :body="props.body"
            :ctas="props.ctas"
            :expandable-text-blocks="props.expandableTextBlocks"
        />
    </UIExpandable>
</template>

<style scoped lang="scss">
.qa-panel {
    border-bottom: 1px solid rgb(0 0 0 / 12%);

    &--borderless {
        border-bottom: unset;
    }

    &.expandable--open {
        .qa-panel__header-icon {
            transform: rotate(45deg);
        }
    }

    &__header {
        position: relative;
        font-size: 18px;
        color: $link-color;
        font-weight: 700;
        padding: 15px 0 15px 0;
        display: flex;
        justify-content: space-between;

        &-icon {
            transition: transform 0.2s ease-out;
        }
    }
}
</style>
